import React, { Component } from "react";
import { Col, Container, Row, } from 'reactstrap';

class HeaderVentas extends Component {

	render() {
		const { renderView, signedIn, } = this.props.initState

		return (
			<Row className={'ws-header-ventas'}>
        {
          signedIn.type === 2 ? (
            <Col>
              <p
                onClick={ () => { this.props.initsetState({ renderView: 'nuevaCompra', }) }}
                className={`ws-btn-switch ${renderView === 'nuevaCompra' ? 'switch-active' : ''}`}>VENTAS</p>
            </Col>
          ) : null
        }
        <Col>
          <p
            onClick={ () => { this.props.initsetState({ renderView: 'general', }, this.goToGeneral) }}
            className={`ws-btn-switch ${renderView === 'general' ? 'switch-active' : ''}`}>RESUMEN</p>
        </Col>
        <Col>
          <p
            onClick={ () => { this.props.initsetState({ renderView: 'altas', }, this.goToGeneral) }}
            className={`ws-btn-switch ${renderView === 'altas' ? 'switch-active' : ''}`}>ALTAS</p>
        </Col>
        <Col>
          <p
            onClick={ () => { this.props.initsetState({ renderView: 'actualiza-costos', }, this.goToGeneral) }}
            className={`ws-btn-switch ${renderView === 'actualiza-costos' ? 'switch-active' : ''}`}>COSTOS</p>
        </Col>
      </Row>
		)
	}
}

export default HeaderVentas